import { Injectable } from '@angular/core';
import type { Plugin1cFindManyQueryInterface } from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-find-many-query.dto'
import type { Plugin1cPageInterface } from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-page.dto'
import type { Plugin1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-find.dto'
import type { Plugin1cFormInterface } from '@zaoblako/shared/modules/integration/dtos/plugin-1c/plugin-1c-form.dto'

import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisSystem1cService extends BaseService {
  protected baseUrl = '/basis/system/plugin-1c';

  public findMany(params?: Plugin1cFindManyQueryInterface): Observable<Plugin1cPageInterface> {
    return this.http.get<Plugin1cPageInterface>(this.baseUrl, {
      params: params
        ? this.objectToHttpParams(params)
        : {}
    });
  }

  public download(): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/latest/download`, { responseType: 'arraybuffer' as any });
  }

  public downloadByVersion(version: string): Observable<BlobPart> {
    return this.http.get<BlobPart>(`${this.baseUrl}/${version}/download`, { responseType: 'arraybuffer' as any });
  }

  public getLatest(select?: (keyof Plugin1cFindInterface)[]): Observable<Plugin1cFindInterface> {
    return this.http.get<Plugin1cFindInterface>(`${this.baseUrl}/latest`, {
      params: select?.length
        ? this.objectToHttpParams({ select })
        : {}
    });
  }

  public setVersion(version: string, body: Plugin1cFormInterface): Observable<Plugin1cFindInterface> {
    return this.http.put<Plugin1cFindInterface>(`${this.baseUrl}/${version}`, body);
  }

  public deleteByVersion(version: string): Observable<Plugin1cFindInterface> {
    return this.http.delete<Plugin1cFindInterface>(`${this.baseUrl}/${version}`);
  }
}
